<div class="header-container">
    <div class="header-primary-container">
        <div class="container-menu-responsive navbar navbar-expand-lg">
            <button class="nav-responsive" type="button" role="button" data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                aria-label="Menú de navegación, Se abrirá menú con más opciones" (click)="clickMenuResponsive($event)">
                <span class="govco-svg govco-bars"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <app-sidebar [verUrlRepository]="true"></app-sidebar>
            </div>
        </div>
        <div class="header-title-icon">
            <div class="header-icon">
                <a href="{{urls.home}}" rel="noopener" target="_blank">
                    <img src="{{urls.images}}logo.svg" height="60" width="180" alt="Logo Gov.co">
                </a>
            </div>
            <div class="d-flex align-items-center header-title">
                <h1 class="mb-0">
                    {{ nombrePortal }} <br />
                    <span class="text-2">{{ subNombrePortal }}</span>
                </h1>
            </div>
        </div>
        <app-candy-box></app-candy-box>
    </div>
    <div class="header-secundary-container">
        <app-version-menu></app-version-menu>
        <div class="search-container">
            <app-search></app-search>
        </div>
        <app-link-repository [urlRepository]="urlRepository" [headerBDC]="true"></app-link-repository>
    </div>
</div>
